import { render } from "./PenyataBaki.vue?vue&type=template&id=0f754806"
import script from "./PenyataBaki.vue?vue&type=script&lang=js"
export * from "./PenyataBaki.vue?vue&type=script&lang=js"

import "./PenyataBaki.vue?vue&type=style&index=0&id=0f754806&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__